import PortfolioCorrelationsWidgetView from './PortfolioCorrelationsWidgetView.tsx';
import PortfolioCorrelationsWidgetSettingsContainer, {
  type PortfolioCorrelationsWidgetState,
} from './PortfolioCorrelationsWidgetSettings.tsx';
import type { CustomWidgetDescription } from '../../management/customDashboard/CustomWidgetDescription.types.ts';
import { range7Days } from '../../predefinedDateRanges.ts';
import { IWindowType } from '../../../generated/graphql.tsx';
import ShowChartIcon from '@mui/icons-material/ShowChart';

export const portfolioCorrelationsWidget: CustomWidgetDescription = {
  type: 'portfolioCorrelations',
  name: 'Portfolio correlations',
  description: 'Displays historical correlations between different portfolio definitions',
  icon: () => <ShowChartIcon />,
  viewComponent: PortfolioCorrelationsWidgetView,
  settingsComponent: PortfolioCorrelationsWidgetSettingsContainer,
  initialState: {
    title: 'Portfolio Correlations',
    portfolioIds: [],
    predefinedDateRange: range7Days.label,
    windowType: IWindowType.Expanding,
    warmUpPeriod: 10,
  } satisfies PortfolioCorrelationsWidgetState,
  initialW: 6,
  initialH: 4,
};
